/* MGFX - Herbs Blend — carousel arrow navigation */
(function () {
  "use strict";

  function initHerbsCarousel(root) {
    var track = root.querySelector("[data-herbs-track]");
    var prevBtn = root.querySelector("[data-herbs-prev]");
    var nextBtn = root.querySelector("[data-herbs-next]");
    if (!track || !prevBtn || !nextBtn) return;

    function cardWidth() {
      var card = track.querySelector(".mgfx-herbs__card");
      if (!card) return track.clientWidth;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || "0") || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    prevBtn.addEventListener("click", function () {
      track.scrollBy({ left: -cardWidth(), behavior: "smooth" });
    });

    nextBtn.addEventListener("click", function () {
      track.scrollBy({ left: cardWidth(), behavior: "smooth" });
    });

    track.addEventListener("scroll", updateButtons, { passive: true });
    window.addEventListener("resize", updateButtons);
    updateButtons();
  }

  function init() {
    var roots = document.querySelectorAll("[data-mgfx-herbs]");
    roots.forEach(initHerbsCarousel);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
